var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tags empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.50861,31.7868247 C111.284828,27.8422809 104.071267,27.7779101 98.891485,31.6238607 L91.558146,24.0778124 C89.1039219,21.6235744 85.147178,21.5975002 82.6848056,24.0598864 L24.0580194,82.939597 C21.612758,85.3848719 21.6119433,89.3448972 24.0580194,91.7909871 L32.3316553,100.063855 C30.4836539,105.352852 31.816692,111.349112 35.8573618,115.388175 C39.8972167,119.429683 45.8934437,120.761914 51.1824108,118.915531 L59.456047,127.188399 C61.9013081,129.633674 65.8629407,129.632859 68.303313,127.191658 L127.189211,68.5580233 C129.635287,66.1119336 129.635287,62.1543528 127.189211,59.7090779 C127.184322,59.7041889 124.662197,57.2532102 119.622835,52.3561419 C123.454912,47.2113681 123.440245,39.9945071 119.459057,34.7372882 L116.50861,31.7868247 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.50861,31.7868247 C111.284828,27.8422809 104.071267,27.7779101 98.891485,31.6238607 L91.558146,24.0778124 C89.1039219,21.6235744 85.147178,21.5975002 82.6848056,24.0598864 L24.0580194,82.939597 C21.612758,85.3848719 21.6119433,89.3448972 24.0580194,91.7909871 L32.3316553,100.063855 C30.4836539,105.352852 31.816692,111.349112 35.8573618,115.388175 C39.8972167,119.429683 45.8934437,120.761914 51.1824108,118.915531 L59.456047,127.188399 C61.9013081,129.633674 65.8629407,129.632859 68.303313,127.191658 L127.189211,68.5580233 C129.635287,66.1119336 129.635287,62.1543528 127.189211,59.7090779 C127.184322,59.7041889 124.662197,57.2532102 119.622835,52.3561419 C123.454912,47.2113681 123.440245,39.9945071 119.459057,34.7372882 L116.50861,31.7868247 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tags-empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "store-slot-empty"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(56.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47-Copy",
    transform: "translate(110.961720, 102.260326) rotate(-26.000000) translate(-110.961720, -102.260326) translate(34.961720, 26.260326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero",
    transform: "translate(75.623768, 75.623768) rotate(-45.000000) translate(-75.623768, -75.623768) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M116.179812,32.1651337 C111.135641,28.3750431 104.182341,28.3181936 99.1895528,32.0253026 L98.8380387,32.2862993 L98.532914,31.9723242 L91.2045916,24.4313648 C88.9388152,22.1655756 85.2986942,22.153092 83.0391192,24.412678 L24.4115737,83.2931494 C22.1612817,85.5434539 22.16105,89.1868983 24.4115563,91.4374173 L32.9072543,99.9323264 L32.803672,100.22878 C31.0088426,105.365598 32.3277281,111.152979 36.2109875,115.034694 C40.0927292,118.918024 45.8799044,120.237048 51.0176138,118.44347 L51.3139755,118.34001 L59.8096014,126.834847 C62.0588349,129.084093 65.7038385,129.084788 67.9505194,126.837347 L126.835656,68.2044708 C129.086462,65.9536529 129.086462,62.3126985 126.835651,60.0626252 C126.833716,60.0606902 123.878772,57.1891017 119.27438,52.7147215 L118.959909,52.4091298 L119.221845,52.0574656 C122.939052,47.0669112 122.888957,40.0947382 119.105502,35.0908406 L116.179812,32.1651337 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.7852848,33.334989 C77.0380869,35.0821967 74.2058793,35.0821967 72.4586814,33.334989 C70.7132306,31.5895284 70.7132306,28.750316 72.4569343,27.0066025 C74.2023851,25.2646365 77.0415816,25.2611423 78.7852848,27.0066025 C80.5307356,28.7520631 80.5377244,31.5825396 78.7852848,33.334989 Z",
    id: "Path",
    fill: "#EB8181",
    transform: "translate(75.623185, 30.172106) rotate(-45.000000) translate(-75.623185, -30.172106) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EB8181",
    fillRule: "nonzero",
    transform: "translate(75.622841, 76.471369) rotate(-45.000000) translate(-75.622841, -76.471369) ",
    points: "36.0228411 86.6022455 85.7532061 36.8713692 115.222841 66.3413071 65.4924761 116.071369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5346204,71.3826271 C72.8738353,69.0431078 72.8738353,65.2361142 70.5346204,62.8965947 C68.1899366,60.5516055 64.3928144,60.5508239 62.0481305,62.8965947 C59.7026652,65.2415839 59.7026652,69.0368566 62.0481305,71.3826271 C64.3873452,73.7221464 68.1946243,73.722928 70.5346204,71.3826271 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(66.289032, 67.137560) rotate(-45.000000) translate(-66.289032, -67.137560) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8671355,80.7142411 C77.5217848,83.0588668 77.5217848,86.8538486 79.8671355,89.1984743 C82.2117049,91.5423188 86.0078605,91.5430998 88.353211,89.1984743 C90.6930929,86.8593158 90.6930929,83.0533996 88.353211,80.7142411 C86.0086417,78.3711776 82.2117049,78.3703966 79.8671355,80.7142411 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(84.108122, 84.956651) rotate(-45.000000) translate(-84.108122, -84.956651) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4228411,80.4228411 L94.8228411,70.8228411",
    id: "Line-44",
    stroke: "#FFFFFF",
    strokeWidth: 2.4,
    strokeLinecap: "square",
    transform: "translate(75.622841, 75.622841) rotate(-45.000000) translate(-75.622841, -75.622841) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(85.000000, 106.200000) rotate(7.000000) translate(-85.000000, -106.200000) translate(9.000000, 30.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero",
    transform: "translate(75.623768, 75.623768) rotate(-45.000000) translate(-75.623768, -75.623768) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M116.179812,32.1651337 C111.135641,28.3750431 104.182341,28.3181936 99.1895528,32.0253026 L98.8380387,32.2862993 L98.532914,31.9723242 L91.2045916,24.4313648 C88.9388152,22.1655756 85.2986942,22.153092 83.0391192,24.412678 L24.4115737,83.2931494 C22.1612817,85.5434539 22.16105,89.1868983 24.4115563,91.4374173 L32.9072543,99.9323264 L32.803672,100.22878 C31.0088426,105.365598 32.3277281,111.152979 36.2109875,115.034694 C40.0927292,118.918024 45.8799044,120.237048 51.0176138,118.44347 L51.3139755,118.34001 L59.8096014,126.834847 C62.0588349,129.084093 65.7038385,129.084788 67.9505194,126.837347 L126.835656,68.2044708 C129.086462,65.9536529 129.086462,62.3126985 126.835651,60.0626252 C126.833716,60.0606902 123.878772,57.1891017 119.27438,52.7147215 L118.959909,52.4091298 L119.221845,52.0574656 C122.939052,47.0669112 122.888957,40.0947382 119.105502,35.0908406 L116.179812,32.1651337 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.7852848,33.334989 C77.0380869,35.0821967 74.2058793,35.0821967 72.4586814,33.334989 C70.7132306,31.5895284 70.7132306,28.750316 72.4569343,27.0066025 C74.2023851,25.2646365 77.0415816,25.2611423 78.7852848,27.0066025 C80.5307356,28.7520631 80.5377244,31.5825396 78.7852848,33.334989 Z",
    id: "Path",
    fill: "#EB8181",
    transform: "translate(75.623185, 30.172106) rotate(-45.000000) translate(-75.623185, -30.172106) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#87D5FA",
    fillRule: "nonzero",
    transform: "translate(75.622841, 76.471369) rotate(-45.000000) translate(-75.622841, -76.471369) ",
    points: "36.0228411 86.6022455 85.7532061 36.8713692 115.222841 66.3413071 65.4924761 116.071369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5346204,71.3826271 C72.8738353,69.0431078 72.8738353,65.2361142 70.5346204,62.8965947 C68.1899366,60.5516055 64.3928144,60.5508239 62.0481305,62.8965947 C59.7026652,65.2415839 59.7026652,69.0368566 62.0481305,71.3826271 C64.3873452,73.7221464 68.1946243,73.722928 70.5346204,71.3826271 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(66.289032, 67.137560) rotate(-45.000000) translate(-66.289032, -67.137560) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8671355,80.7142411 C77.5217848,83.0588668 77.5217848,86.8538486 79.8671355,89.1984743 C82.2117049,91.5423188 86.0078605,91.5430998 88.353211,89.1984743 C90.6930929,86.8593158 90.6930929,83.0533996 88.353211,80.7142411 C86.0086417,78.3711776 82.2117049,78.3703966 79.8671355,80.7142411 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(84.108122, 84.956651) rotate(-45.000000) translate(-84.108122, -84.956651) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4228411,80.4228411 L94.8228411,70.8228411",
    id: "Line-44",
    stroke: "#FFFFFF",
    strokeWidth: 2.4,
    strokeLinecap: "square",
    transform: "translate(75.622841, 75.622841) rotate(-45.000000) translate(-75.622841, -75.622841) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsEmpty);
export default __webpack_public_path__ + "static/media/tags-empty.ff2178c621edfc9f4c47afa0adb2f53a.svg";
export { ForwardRef as ReactComponent };